import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  margin: 20px 0;

  a {
    display: flex;
    align-self: center;
  }
`;

export const BoxClasses = styled.div`
  display: flex;
  gap: 15px !important;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const ColumnsClasses = styled.div`
  width: 100%;
`;

export const WrappreTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  margin: 10px 0;

  div {
    display: flex;
    gap: 10px;

    svg {
      cursor: pointer;
    }
  }
`;

export const Label = styled.div`
  color: #004fff;
  font-size: 19px;
  font-weight: 600;
  line-height: 23px;
`;

export const Time = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;

  color: #004fff;
  font-size: 19px;
  font-weight: 400;
  line-height: 20px;
`;

export const CurrentTime = styled.button`
  font-size: 11px;
  color: #004fff;

  padding: 5px 12px;
  border-radius: 26px;
  border: 1px solid #004fff;
  background-color: #fff;
  cursor: pointer;
`;
